import {post} from '@/request/request';


export function getIndex() {
    return post("index/index", {})
}
export function getDateBill(data) {
    return post("index/getDateBill", data)
}
export function getDateApp(data) {
    return post("index/getDateApp", data)
}
export function getDateManage(data) {
    return post("index/getDateManage", data)
}